import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthContext';

/**
 * useAuth — основной hook для доступа к auth-state.
 *
 * Использование:
 *   const { user, status, login, logout } = useAuth();
 *
 * Бросает ошибку, если вызван вне <AuthProvider>.
 */
export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth должен использоваться внутри <AuthProvider>');
  }
  return ctx;
}
